import { Store } from '@ngrx/store';
import { Component, input, Output, EventEmitter } from '@angular/core';
import { VesselTransitStatus } from '@pmis3/vessel-activity-core';
import { CommonModule } from '@angular/common';
import { IVesselVisit } from '@pmis3/vessel-activity-core';
import { VesselVisitStepperComponent } from '../vessel-visit-stepper/vessel-visit-stepper.component';
import { VesselActivityHelper } from '@pmis3/vessel-activity-core';
import { KENDO_BUTTONS } from "@progress/kendo-angular-buttons";

@Component({
    selector: 'pmis3-vessel-visit-grid-item',
    standalone: true,
    imports: [
        CommonModule,
        VesselVisitStepperComponent,
        KENDO_BUTTONS
    ],
    templateUrl: 'vessel-visit-grid-item.component.html',
})
export class VesselVisitGridItemComponent {
    @Output() selectVesselVisit = new EventEmitter<void>();

    vesselVisit = input.required<IVesselVisit>();
    disableStepper = true;

    constructor(private store: Store<any>) {}

    vesselVisitStatusColour(status: VesselTransitStatus | undefined): string {
        ///TEMPORARY CODE - NEEDS TO BE REMOVED
        switch (status) {
            case VesselTransitStatus.Approved:
                return 'bg-green';
            case VesselTransitStatus.Cancelled:
                return 'bg-black';
            case VesselTransitStatus.Completed:
                return 'bg-grey';
            case VesselTransitStatus.Pending:
                return 'bg-orange';
            default:
                return 'bg-grey';
        }
    }

    isVesselStop(index: number): boolean {
        const vesselActivities = this.vesselVisit()?.vesselActivities;
        const vesselActivity = vesselActivities?.[index];

        return !!vesselActivity && (VesselActivityHelper.isVesselStop(vesselActivity) || index == vesselActivities.length - 1);
    }

    onSelectVesselVisit() {
        this.selectVesselVisit.emit();
    }
}